import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/images/icon/delete.svg';

var _hoisted_1 = /*#__PURE__*/_createVNode("i", {
  class: "icon-Home"
}, null, -1);

var _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "txt"
}, " 首頁 ", -1);

var _hoisted_3 = /*#__PURE__*/_createVNode("i", {
  class: "icon-basket"
}, null, -1);

var _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "txt"
}, " 訂購 ", -1);

var _hoisted_5 = /*#__PURE__*/_createVNode("i", {
  class: "icon-basket"
}, null, -1);

var _hoisted_6 = /*#__PURE__*/_createVNode("div", {
  class: "txt"
}, " 訂購 ", -1);

var _hoisted_7 = {
  class: "col-item main"
};

var _hoisted_8 = /*#__PURE__*/_createVNode("i", {
  class: "icon-wallet"
}, null, -1);

var _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "txt",
  style: {
    "opacity": "0"
  }
}, " 訂單 ", -1);

var _hoisted_10 = /*#__PURE__*/_createVNode("i", {
  class: "icon-interface"
}, null, -1);

var _hoisted_11 = /*#__PURE__*/_createVNode("div", {
  class: "txt"
}, " 訂單 ", -1);

var _hoisted_12 = /*#__PURE__*/_createVNode("i", {
  class: "icon-user"
}, null, -1);

var _hoisted_13 = /*#__PURE__*/_createVNode("div", {
  class: "txt"
}, " 帳戶 ", -1);

var _hoisted_14 = /*#__PURE__*/_createVNode("div", {
  class: "popup popup-tablet-fullscreen popup-sty-modal popup-bonus-list",
  id: "popup-bonus-list"
}, [/*#__PURE__*/_createVNode("div", {
  class: "view"
}, [/*#__PURE__*/_createVNode("div", {
  class: "page"
}, [/*#__PURE__*/_createVNode("div", {
  class: "navbar"
}, [/*#__PURE__*/_createVNode("div", {
  class: "navbar-inner"
}, [/*#__PURE__*/_createVNode("div", {
  class: "left"
}), /*#__PURE__*/_createVNode("div", {
  class: "title"
}), /*#__PURE__*/_createVNode("div", {
  class: "right"
})])]), /*#__PURE__*/_createVNode("div", {
  class: "page-content popup-modal-centered"
}, [/*#__PURE__*/_createVNode("div", {
  class: "page-inner"
}, [/*#__PURE__*/_createVNode("div", {
  class: "popup-modal-content no-bg"
}, [/*#__PURE__*/_createVNode("div", {
  class: "head-card sty-has-badge-bar sty-slash"
}, [/*#__PURE__*/_createVNode("div", {
  class: "card-head"
}, [/*#__PURE__*/_createVNode("span", {
  class: "cell-ex"
}, "說明"), /*#__PURE__*/_createVNode("span", {
  class: "cell-bonus"
}, "獎金(稅前)"), /*#__PURE__*/_createVNode("span", {
  class: "cell-time"
}, "時間")]), /*#__PURE__*/_createVNode("div", {
  class: "card-body"
}, [/*#__PURE__*/_createVNode("div", {
  class: "bonus-list"
}, [/*#__PURE__*/_createVNode("div", {
  class: "item"
}, [/*#__PURE__*/_createVNode("div", {
  class: "item-title cell-ex"
}, " 推薦總代 "), /*#__PURE__*/_createVNode("div", {
  class: "item-content cell-bonus"
}, " + 30,000 "), /*#__PURE__*/_createVNode("div", {
  class: "item-content cell-time"
}, [/*#__PURE__*/_createTextVNode(" 2021-04-30"), /*#__PURE__*/_createVNode("br"), /*#__PURE__*/_createTextVNode(" 18:52:10 ")])]), /*#__PURE__*/_createVNode("div", {
  class: "item"
}, [/*#__PURE__*/_createVNode("div", {
  class: "item-title cell-ex"
}, " 推薦總代 "), /*#__PURE__*/_createVNode("div", {
  class: "item-content cell-bonus"
}, " + 30,000 "), /*#__PURE__*/_createVNode("div", {
  class: "item-content cell-time"
}, [/*#__PURE__*/_createTextVNode(" 2021-04-30"), /*#__PURE__*/_createVNode("br"), /*#__PURE__*/_createTextVNode(" 18:52:10 ")])])]), /*#__PURE__*/_createVNode("div", {
  class: "v-spacer-30px"
})])]), /*#__PURE__*/_createVNode("a", {
  class: "link popup-close popup-close-auto popup-tail-close"
}, [/*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
})])])])])])])], -1);

var _hoisted_15 = /*#__PURE__*/_createVNode("div", {
  class: "popup popup-tablet-fullscreen popup-sty-modal popup-recommends-list",
  id: "popup-recommends-list"
}, [/*#__PURE__*/_createVNode("div", {
  class: "view"
}, [/*#__PURE__*/_createVNode("div", {
  class: "page"
}, [/*#__PURE__*/_createVNode("div", {
  class: "navbar"
}, [/*#__PURE__*/_createVNode("div", {
  class: "navbar-inner"
}, [/*#__PURE__*/_createVNode("div", {
  class: "left"
}), /*#__PURE__*/_createVNode("div", {
  class: "title"
}), /*#__PURE__*/_createVNode("div", {
  class: "right"
})])]), /*#__PURE__*/_createVNode("div", {
  class: "page-content popup-modal-centered"
}, [/*#__PURE__*/_createVNode("div", {
  class: "page-inner"
}, [/*#__PURE__*/_createVNode("div", {
  class: "popup-modal-content no-bg"
}, [/*#__PURE__*/_createVNode("div", {
  class: "head-card sty-has-badge-bar sty-slash"
}, [/*#__PURE__*/_createVNode("div", {
  class: "card-head"
}, [/*#__PURE__*/_createVNode("span", {
  class: "cell-account"
}, "推薦會員帳號"), /*#__PURE__*/_createVNode("span", {
  class: "cell-time"
}, "加入時間")]), /*#__PURE__*/_createVNode("div", {
  class: "card-body"
}, [/*#__PURE__*/_createVNode("div", {
  class: "recommends-list"
}, [/*#__PURE__*/_createVNode("div", {
  class: "item"
}, [/*#__PURE__*/_createVNode("div", {
  class: "item-title cell-account"
}, " 王O名 "), /*#__PURE__*/_createVNode("div", {
  class: "item-content cell-time"
}, " 2021-04-30 18:52:10 ")]), /*#__PURE__*/_createVNode("div", {
  class: "item"
}, [/*#__PURE__*/_createVNode("div", {
  class: "item-title cell-account"
}, " 林O王 "), /*#__PURE__*/_createVNode("div", {
  class: "item-content cell-time"
}, " 2021-04-25 16:31:50 ")]), /*#__PURE__*/_createVNode("div", {
  class: "item"
}, [/*#__PURE__*/_createVNode("div", {
  class: "item-title cell-account"
}, " 和O名 "), /*#__PURE__*/_createVNode("div", {
  class: "item-content cell-time"
}, " 2021-04-18 14:42:20 ")])]), /*#__PURE__*/_createVNode("div", {
  class: "v-spacer-30px"
})])]), /*#__PURE__*/_createVNode("a", {
  class: "link popup-close popup-close-auto popup-tail-close"
}, [/*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
})])])])])])])], -1);

var _hoisted_16 = {
  class: "popup popup-tablet-fullscreen popup-crop_picture"
};
var _hoisted_17 = {
  class: "view"
};
var _hoisted_18 = {
  class: "page"
};
var _hoisted_19 = {
  class: "navbar text-color-white border-color-gray"
};

var _hoisted_20 = /*#__PURE__*/_createVNode("div", {
  class: "navbar-bg"
}, null, -1);

var _hoisted_21 = {
  class: "navbar-inner"
};
var _hoisted_22 = {
  class: "left"
};

var _hoisted_23 = /*#__PURE__*/_createVNode("i", {
  class: "icon-angle-left"
}, null, -1);

var _hoisted_24 = {
  class: "page-content"
};
var _hoisted_25 = {
  class: "page-content-inner"
};
var _hoisted_26 = {
  class: "page-inner"
};
var _hoisted_27 = {
  class: "crop_picture_block"
};

var _hoisted_28 = /*#__PURE__*/_createVNode("input", {
  type: "file",
  id: "crop_picture_file",
  accept: "image/jpg,image/jpeg,image/png",
  style: {
    "display": "none"
  }
}, null, -1);

var _hoisted_29 = {
  class: "crop_picture_wrap",
  id: "crop_picture_select_trigger"
};

var _hoisted_30 = /*#__PURE__*/_createVNode("div", {
  class: "form-group",
  id: "crop_picture_select_group"
}, [/*#__PURE__*/_createVNode("div", {
  class: "common_preview",
  id: "crop_picture_preview"
})], -1);

var _hoisted_31 = {
  type: "button",
  id: "crop_picture_select_btn",
  class: "bg-theme"
};

var _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"explain-wrap\"><h3 class=\"crop_picture_title text-theme\">建議尺寸：<span id=\"crop_picture_pic_size\"></span></h3><small class=\"crop_picture_tip \">可視範圍即為預覽效果<br>移動位置以拖曳方式操作</small></div><div class=\"crop_picture-btn-wrap\"><div class=\"row\"><div class=\"col-50\"><button type=\"button\" id=\"crop_picture_upload_btn\" class=\"col button btn-gt-theme size-h-45px\">上傳圖片</button></div><div class=\"col-50\"><button data-deg=\"90\" type=\"button\" id=\"crop_picture_rotate_btn\" class=\"col button btn-gt-theme size-h-45px\"><i class=\"btn-before fa fa-repeat btn-icon\" aria-hidden=\"true\"></i> 旋轉圖片 </button></div></div></div><div class=\"v-spacer-30px\"></div>", 3);

var _hoisted_35 = {
  class: "popup popup-tablet-fullscreen popup-notice",
  id: "popup-default"
};
var _hoisted_36 = {
  class: "view"
};
var _hoisted_37 = {
  class: "page"
};
var _hoisted_38 = {
  class: "navbar"
};

var _hoisted_39 = /*#__PURE__*/_createVNode("div", {
  class: "navbar-bg"
}, null, -1);

var _hoisted_40 = {
  class: "navbar-inner"
};

var _hoisted_41 = /*#__PURE__*/_createVNode("div", {
  class: "left"
}, null, -1);

var _hoisted_42 = /*#__PURE__*/_createVNode("div", {
  class: "title"
}, null, -1);

var _hoisted_43 = {
  class: "right"
};
var _hoisted_44 = {
  class: "link popup-close popup-close-auto"
};

var _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div class=\"page-content\"><div class=\"page-content-inner h-100 padding-vertical\"><div class=\"article-block\"><div class=\"section-simple\"><img src=\"\" alt=\"\" srcset=\"\" class=\"margin-bottom popup-main-media\"><div></div></div></div></div></div>", 1);

var _hoisted_46 = {
  class: "popup popup-tablet-fullscreen popup-sty-modal",
  id: "popup-sty-modal-default"
};
var _hoisted_47 = {
  class: "view"
};
var _hoisted_48 = {
  class: "page"
};
var _hoisted_49 = {
  class: "navbar"
};
var _hoisted_50 = {
  class: "navbar-inner"
};

var _hoisted_51 = /*#__PURE__*/_createVNode("div", {
  class: "left"
}, null, -1);

var _hoisted_52 = /*#__PURE__*/_createVNode("div", {
  class: "title"
}, null, -1);

var _hoisted_53 = {
  class: "right"
};
var _hoisted_54 = {
  class: "link popup-close popup-close-auto"
};

var _hoisted_55 = /*#__PURE__*/_createVNode("div", {
  class: "page-content popup-modal-centered"
}, [/*#__PURE__*/_createVNode("div", {
  class: "page-inner"
}, [/*#__PURE__*/_createVNode("div", {
  class: "popup-modal-content no-bg"
})])], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_f7_view = _resolveComponent("f7-view");

  var _component_f7_link = _resolveComponent("f7-link");

  var _component_f7_toolbar = _resolveComponent("f7-toolbar");

  var _component_f7_views = _resolveComponent("f7-views");

  var _component_f7_app = _resolveComponent("f7-app");

  var _component_f7_icon = _resolveComponent("f7-icon");

  return _openBlock(), _createBlock(_Fragment, null, [_createVNode(_component_f7_app, $setup.f7params, {
    default: _withCtx(function () {
      return [_createVNode(_component_f7_views, {
        tabs: "",
        class: "safe-areas"
      }, {
        default: _withCtx(function () {
          return [$setup.viewSwitcher('/') ? (_openBlock(), _createBlock(_component_f7_view, {
            key: 0,
            id: "view-login",
            tab: "",
            main: $setup.viewSwitcher('/'),
            "tab-active": $setup.viewSwitcher('/'),
            url: "/"
          }, null, 8, ["main", "tab-active"])) : _createCommentVNode("", true), $setup.viewSwitcher('index') ? (_openBlock(), _createBlock(_component_f7_view, {
            key: 1,
            id: "view-main",
            "data-main": $setup.viewSwitcher('index'),
            tab: "",
            main: $setup.viewSwitcher('index'),
            "tab-active": $setup.viewSwitcher('index'),
            url: "/index"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_f7_toolbar, {
                bottom: "",
                class: "toolbar-menu"
              }, {
                default: _withCtx(function () {
                  return [_createVNode("div", {
                    class: ["col-item", {
                      'is-active': $setup.toolbarMenuActiveName == '/index'
                    }]
                  }, [_createVNode(_component_f7_link, {
                    onClick: _cache[1] || (_cache[1] = function ($event) {
                      return $setup.refreshPage('/index');
                    }),
                    class: "link menu-link"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_1, _hoisted_2];
                    }),
                    _: 1
                  })], 2), _createVNode("div", {
                    class: ["col-item", {
                      'is-active': $setup.toolbarMenuActiveName == '/product_list' || $setup.toolbarMenuActiveName == '/product_list_for_casual_buy'
                    }]
                  }, [_withDirectives(_createVNode(_component_f7_link, {
                    onClick: _cache[2] || (_cache[2] = function ($event) {
                      return $setup.refreshPage('/product_list');
                    }),
                    class: "link menu-link"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_3, _hoisted_4];
                    }),
                    _: 1
                  }, 512), [[_vShow, $setup.store.state.auth.category_id !== $setup.mukiConst.memberCategory.CASUAL_BUY]]), _withDirectives(_createVNode(_component_f7_link, {
                    onClick: _cache[3] || (_cache[3] = function ($event) {
                      return $setup.refreshPage('/product_list_for_casual_buy');
                    }),
                    class: "link menu-link casual"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_5, _hoisted_6];
                    }),
                    _: 1
                  }, 512), [[_vShow, $setup.store.state.auth.category_id === $setup.mukiConst.memberCategory.CASUAL_BUY]])], 2), _createVNode("div", _hoisted_7, [_createVNode("a", {
                    onClick: _cache[4] || (_cache[4] = function ($event) {
                      return $setup.refreshPage('/wallet');
                    }),
                    class: "link menu-link",
                    "data-page": "index_supervisor"
                  }, [_hoisted_8, _hoisted_9])]), _createVNode("div", {
                    class: ["col-item", {
                      'is-active': $setup.toolbarMenuActiveName == '/order_list'
                    }]
                  }, [_createVNode("a", {
                    onClick: _cache[5] || (_cache[5] = function ($event) {
                      return $setup.refreshPage('/order_list');
                    }),
                    class: "link menu-link"
                  }, [_hoisted_10, _hoisted_11])], 2), _createVNode("div", {
                    class: ["col-item", {
                      'is-active': $setup.toolbarMenuActiveName == '/my_account'
                    }]
                  }, [_createVNode("a", {
                    onClick: _cache[6] || (_cache[6] = function ($event) {
                      return $setup.refreshPage('/my_account');
                    }),
                    transition: "f7-fade",
                    "ignore-cache": true,
                    class: "link menu-link"
                  }, [_hoisted_12, _hoisted_13])], 2)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["data-main", "main", "tab-active"])) : _createCommentVNode("", true), $setup.viewSwitcher('err') ? (_openBlock(), _createBlock(_component_f7_view, {
            key: 2,
            id: "view-err",
            tab: "",
            main: $setup.viewSwitcher('err'),
            "tab-active": $setup.viewSwitcher('err'),
            url: "/err/"
          }, null, 8, ["main", "tab-active"])) : _createCommentVNode("", true), $setup.standAloneViewDetech('news_detailed_share').isThisView ? (_openBlock(), _createBlock(_component_f7_view, {
            key: 3,
            id: "view-news-detailed",
            tab: "",
            main: $setup.standAloneViewDetech('news_detailed_share').isThisView,
            "tab-active": $setup.standAloneViewDetech('news_detailed_share').isThisView,
            url: $setup.standAloneViewDetech('news_detailed_share').f7path
          }, null, 8, ["main", "tab-active", "url"])) : _createCommentVNode("", true)];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 16), _hoisted_14, _hoisted_15, _createVNode("div", _hoisted_16, [_createVNode("div", _hoisted_17, [_createVNode("div", _hoisted_18, [_createVNode("div", _hoisted_19, [_hoisted_20, _createVNode("div", _hoisted_21, [_createVNode("div", _hoisted_22, [_createVNode(_component_f7_link, {
    class: "",
    "popup-close": ""
  }, {
    default: _withCtx(function () {
      return [_hoisted_23];
    }),
    _: 1
  })])])]), _createVNode("div", _hoisted_24, [_createVNode("div", _hoisted_25, [_createVNode("div", _hoisted_26, [_createVNode("div", _hoisted_27, [_hoisted_28, _createVNode("div", _hoisted_29, [_hoisted_30, _createVNode("button", _hoisted_31, [_createVNode(_component_f7_icon, {
    f7: "camera_fill"
  })])]), _hoisted_32])])])])])])]), _createVNode("div", _hoisted_35, [_createVNode("div", _hoisted_36, [_createVNode("div", _hoisted_37, [_createVNode("div", _hoisted_38, [_hoisted_39, _createVNode("div", _hoisted_40, [_hoisted_41, _hoisted_42, _createVNode("div", _hoisted_43, [_createVNode("a", _hoisted_44, [_createVNode(_component_f7_icon, {
    f7: "multiply"
  })])])])]), _hoisted_45])])]), _createVNode("div", _hoisted_46, [_createVNode("div", _hoisted_47, [_createVNode("div", _hoisted_48, [_createVNode("div", _hoisted_49, [_createVNode("div", _hoisted_50, [_hoisted_51, _hoisted_52, _createVNode("div", _hoisted_53, [_createVNode("a", _hoisted_54, [_createVNode(_component_f7_icon, {
    f7: "multiply"
  })])])])]), _hoisted_55])])])], 64);
}